import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';
//funcionalidades
import relatorios from './modulos/relatorios';
import alterarSenha from "./modulos/alterarSenha";
import parametros from "./modulos/parametros";
import funcionarios from "./modulos/funcionarios";
import painel from "./modulos/painel";
import gestaoAcesso from './modulos/gestaoAcesso';
import fornecedor from "./modulos/fornecedor";
import comprador from './modulos/comprador';
import setor from './modulos/setor';
import porte from './modulos/porte';
import ramoAtuacao from './modulos/ramoAtuacao';
import atividadeEconomica from './modulos/atividadeEconomica';
import oferta from './modulos/oferta';
import demanda from './modulos/demanda';
import deuMatch from './modulos/deuMatch';
import chat from './modulos/chat';
import ofertaFornecedor from './modulos/ofertaFornecedor';
import dadosFornecededor from './modulos/dadosFornecededor';
import dadosComprador from './modulos/dadosComprador';
import meuCadastro from './modulos/meuCadastro';
import AlterarSenhaResp from './modulos/AlterarSenhaResp';
//Evento
import evento from './modulos/evento';
import eventoTipo from './modulos/eventoTipo';
import eventoEdicao from './modulos/eventoEdicao';
import eventoInscricao from './modulos/eventoInscricao';
import contato from './modulos/contato';
import mensagem from './modulos/mensagem';
import biPetroSupply from './modulos/biPetroSupply';

Vue.use(VueRouter)

const routes = [
    ...relatorios,
    ...alterarSenha,
    ...parametros,
    ...funcionarios,
    ...painel,
    ...gestaoAcesso,
    ...fornecedor,
    ...comprador,
    ...setor,
    ...porte,
    ...ramoAtuacao,
    ...atividadeEconomica,
    ...oferta,
    ...demanda,
    ...chat,
    ...deuMatch,
    ...ofertaFornecedor,
    ...dadosFornecededor,
    ...dadosComprador,
    ...meuCadastro,
    ...AlterarSenhaResp,
    ...evento,
    ...eventoTipo,
    ...eventoEdicao,
    ...eventoInscricao,
    ...contato,
    ...mensagem,
    ...biPetroSupply,
    {
        name: 'Unauthorized',
        path: '/unauthorized',
        meta: {
            title: 'Sem Autorização',
            unauthorized: true,
        },
        component: () => import('@/views/Unauthorized')
    },
    {
        name: 'Login',
        path: '/login',
        props: {
            type: 'usuario',
            formAtivo: 'login',
        },
        meta: {
            loginPage: true
        },
        component: () => import('@/views/Login')
    },
    {
        name: 'EsqueciSenha',
        path: '/esqueci-a-senha',
        props: {
            formAtivo: 'esqueciSenha',
        },
        component: () => import('@/views/Login')
    },
    {
        name: 'CadastreSe',
        path: '/cadastre-se',
        props: {
            formAtivo: 'cadastreSe',
        },    
        component: () => import('@/views/Login')
    },    
    {
        name: 'ConfirmarAlteracaoSenha',
        path: '/conf-senha/:chave?',
        props: {
            formAtivo: 'confSenha',
        },
        component: () => import('@/views/Login')
    },
    {
        name: 'NossosEventos',
        path: '/eventos',
        meta: {
            loginPage: true
        },
        props: route => ({
            tipoContaSelecionado: route.query.tipoContaSelecionado || ''
        }),
        component: () => import('@/views/EventoInscricao/InscrevaSe.vue')
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(async (to, from, next) => {
    await store.restored;
    const {meta} = to;

    function isGoingToLoginPage() {
        return meta.hasOwnProperty('loginPage') && meta.loginPage;
    }

    function isGoingToUnauthorizedPage() {
        return meta.hasOwnProperty('unauthorized') && meta.unauthorized;
    }

    async function handleIsAuthenticated() {
        const defaultHomePage = await store.dispatch('auth/getDefaultHomePage');
        if (isGoingToLoginPage()) {
            next({
                name: defaultHomePage
            });
        } else {
            const authorizedLinks = [...store.getters['auth/authorizedLinks']];
            if (isGoingToUnauthorizedPage()) {
                next();
            } else {
                if (authorizedLinks.some(item => item.startsWith(retornaPrimeiroNivelUrl(to.path)))) {
                    next();
                } else {
                    if (to.path === '/') {
                        next({
                            name: defaultHomePage
                        })
                    } else {
                        next('/unauthorized')
                    }
                }
            }
        }
    }

    async function handleNotAuthenticated() {
        const authorizedLinks = [...store.getters['auth/authorizedLinks']];
        const defaultLoginPage = await store.dispatch('auth/getDefaultLoginPage');
        if (to.path === '/') {
            next({
                name: defaultLoginPage
            })
        } else if (authorizedLinks.some(item => item.startsWith(retornaPrimeiroNivelUrl(to.path)))) {
            next();
        } else if (isGoingToLoginPage()) {
            next();
        } else {
            next({
                name: defaultLoginPage
            })
        }
    }

    if (store.getters['auth/isAuthenticated']) {
        await handleIsAuthenticated();
    } else {
        await handleNotAuthenticated();
    }

    function retornaPrimeiroNivelUrl(path){
        const arrPath = path.split('/');
        const primeiroItem = arrPath[1];
        return "/"+primeiroItem;
    }

})

export default router
